// const BASE_URL = "http://localhost:8080/api/";
const BASE_URL = "http://193.203.160.57:8081/api/";
export const LOGIN = BASE_URL + "login";
export const CREATE_CUSTOMER = BASE_URL + "employee/create/";
export const VIEW_CUSTOMER = BASE_URL + "employee/parent/";
export const DELETE_CUSTOMER = BASE_URL + "employee/";
export const SEND_EMAIL = BASE_URL + "email/send/";
export const SEND_EMAIL_EXCEL = BASE_URL + "email/send/with-excel/";
export const CUSTOMER_BY_ID = BASE_URL + "employee/"
export const CUSTOMER_PROFILE = BASE_URL + "employee/"
export const ADMIN_PROFILE = BASE_URL + "employee/"
